import Base from './base'
import { Me as MeResponse } from '../types/me'

export default class Me extends Base {
  get(): Promise<MeResponse> {
    return this.api.get('me?include_private_fields=true')
  }
}
